export const GLOBALTYPES = {
    AUTH: "AUTH",
    ALERT: "ALERT",
    THEME: 'THEME',
    STATUS: 'STATUS',
    MODAL: 'MODAL',
    SOCKET: 'SOCKET',
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
    CALL: 'CALL',
    PEER: 'PEER',
    GET_USER: 'GET_USER',
    GET_ALL_USERS: 'GET_ALL_USERS',
    GET_ALL_RESTAURANT: 'GET_ALL_RESTAURANT',
    GET_ALL_AMBASSADOR_REQUEST:'GET_ALL_AMBASSADOR_REQUEST',
    LOGOUT:'LOGOUT'
}

export const EditData = (data, id, post) => {
    const newData = data.map(item => 
        (item._id === id ? post : item)
    )
    return newData;
}

export const DeleteData = (data, id) => {
    const newData = data.filter(item => item._id !== id)
    return newData;
}